import { Optional } from "common/utils/types";

import { PastelColor, VividColor } from "../types/colors";

export const getPastelColor = (color: Optional<PastelColor>) => {
  return (color ?? PastelColor.Slate).toLowerCase() as Lowercase<PastelColor>;
};

export const getVividColor = (color: Optional<VividColor>): Lowercase<VividColor> => {
  return (color ?? VividColor.Kiwi).toLowerCase() as Lowercase<VividColor>;
};

/**
 * Convert a hex color to an RGB object.
 * Assume it's in the format "#RRGGBB".
 * This matches the db hex validator.
 */
export const hexToRgb = (hex: string) => {
  if (hex.length !== 7) {
    // invalid
    console.error("Invalid hex color", hex);
    return { r: 0, g: 0, b: 0 };
  }
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return { r, g, b };
};

/**
 * Array of all available vivid colors for user identification.
 * Used for assigning consistent colors to users.
 */
export const USER_COLORS = Object.values(VividColor);

/**
 * Assigns a consistent color to a user based on their ID.
 * Uses modulo to cycle through available colors, ensuring the same user
 * always gets the same color across sessions.
 *
 * @param id - Numeric user ID
 * @returns A vivid color for the user
 */
export const getUserColor = (id: number): VividColor => {
  return USER_COLORS[id % USER_COLORS.length];
};
